import { array } from 'prop-types';
import React, { Fragment } from 'react';
import BuyButtonContainer from '../Containers/BuyButton.container';
import { translate } from '../Services/translation';
import QuantityPurchaseContainer from '../Containers/QuantityPurchase.Container';


const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
    const filteredProducts = result.filter(id => id.category === "Products");
    const filteredBrands = result.filter(id => id.category === "Brands");
    const filteredCategory = result.filter(id => id.category === "Categories");
    const filteredPages = result.filter(id => id.category === "Pages");
    
    return (
        <div className="quick-search-result">
            <div className="row">
                <ul className="quick-search-result--products-wrapper columns small-12 medium-9">
                    {filteredProducts.length > 0 ? <div className="quick-search-result__group-header">{translate('quicksearch.products')}</div> : <div className="quick-search-result__group-header">Inga produkter matchade din sökning</div>}
                    {filteredProducts && filteredProducts.slice(0, 9).map((item, index) => (
                        <Fragment key={`${item.name}-${index}`}>
                            <li key={item.url} className={`quick-search-result__item ${selectedItem === index ? 'quick-search-result__item--selected' : ''}`} >
                                <a className={item.showAll ? 'quick-search-result__show-all' : `quick-search-result__link ${item.url ? '' : 'quick-search-result__link--disabled'}`}
                                    href={(item.showAll ? searchUrl + '&notinstock=true' : item.url)}>
                                    {item.hasImage && item.imageSource && <div className="quick-search-result__image--wrapper"><img className="quick-search-result__image" src={item.imageSource} /></div>}
                                    <div className="quick-search-result__item--title">{item.name}
                                        <span>{item.brand}</span>
                                        {(!item.isInStock || item.isBlocked) && item.isLoggedIn &&
                                            <div className="quicksearch__not-in-stock-wrapper">
                                                <div className="quicksearch__stocktext">
                                                    <div className='out-of-stock'></div>
                                                    <span>{translate('quicksearch.notinstock')}</span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </a>
                                {item.isLoggedIn && item.price &&
                                    <div className="checkout-cart__input-container quantity-purchase">
                                        {item.isInStock && !item.isBlocked &&
                                            <>
                                                {item.price.campaignPrice ? (
                                                    <>
                                                        <div className="quantity-purchase__campaign-price">
                                                            {
                                                                item.formattedPrice
                                                            }
                                                        </div>
                                                    </>
                                                )
                                                    : item.hasBetterPrice === true ? (
                                                        <>
                                                            <div className="quantity-purchase__original-price-lower">
                                                                {
                                                                    item.formattedPrice
                                                                }
                                                            </div>
                                                        </>
                                                    )
                                                        :
                                                        <div className="quantity-purchase__price">
                                                            {
                                                                item.formattedPrice
                                                            }
                                                        </div>
                                                }
                                            </>
                                        }
                                        {item.isInStock && !item.isBlocked ? (
                                            <QuantityPurchaseContainer
                                                {...{
                                                    packageSize:
                                                        item.packageQuantity,
                                                    allowSingleItem: item.singleItemPurchase,
                                                    articleNumber:
                                                        item.articleNumber,
                                                    productName:
                                                        item.name,
                                                    variant: item.name,
                                                    brand: item.brand,
                                                    isKeg: item.isKeg,
                                                    isQuickSearch: true,
                                                    isBlocked: item.isBlocked
                                                }
                                            }
                                            />
                                        ) : (
                                            // placeholder to align height for quicksearch when item not in stock.
                                        <div style={{minHeight: "140px"}}>

                                        </div>)}
                                    </div>
                                }
                            </li>
                        </Fragment>
                    ))}
                </ul>
                <ul className="columns small-12 medium-3 quick-search-result--links-wrapper">
                    {filteredBrands.length > 0 ? <li className="quick-search-result__item quick-search-result__group-header" >{translate('quicksearch.brands')}</li>: ""}
                    {filteredBrands && filteredBrands.slice(0,4).map((item) => (
                        <li key={`${item.name}-${item.url}`}><a href={item.url}>{item.name}</a></li>
                    ))}
                    {filteredCategory.length > 0 ? <li className="quick-search-result__item quick-search-result__group-header" >{translate('quicksearch.categories')}</li> : ""}
                    {filteredCategory && filteredCategory.slice(0,4).map((item) => (
                        <li key={`${item.name}-${item.url}`}><a href={item.url}>{item.name}</a></li>
                    ))}
                    {filteredPages.length > 0 ? <li className="quick-search-result__item quick-search-result__group-header" >{translate('quicksearch.pages')}</li> : ""}
                    {filteredPages && filteredPages.slice(0,4).map((item) => (
                        <li key={`${item.name}-${item.url}`}><a href={item.url}>{item.name}</a></li>
                    ))}
                </ul>
            </div>
            {(filteredBrands.length > 0 || filteredPages.length > 0 || filteredCategory.length > 0 || filteredProducts.length > 0) &&
            <div className="quick-search-result__submit-row columns">
                <a className="quick-search-result__submit-row--button" href={searchUrl + '&notinstock=true'}>{translate('quicksearch.show-all')}</a>
            </div>
            }
        </div>
    )};

export default QuickSearchResult;